import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

export function getUserId(): string {
  if (typeof window === "undefined") return "anon";
  let id = window.localStorage.getItem("user_id");
  if (!id) {
    id = "u_" + Math.random().toString(36).slice(2, 12);
    window.localStorage.setItem("user_id", id);
  }
  return id;
}
